export enum QASEmailResponseTypes {
  VERIFIED = 'verified',
  UNDELIVERABLE = 'undeliverable',
  UNREACHABLE = 'unreachable',
  ILLEGITIMATE = 'illegitimate',
  DISPOSABLE = 'disposable',
  UNKNOWN = 'unknown',
  NOT_VERIFIED = 'not-verified'
}
